
import React from 'react';
import { Star } from 'lucide-react';

export function TestimonialsSection() {
  const testimonials = [
    {
      text: "atWork.ai has transformed our sales process. The AI assistant helps us find qualified leads and personalize outreach at scale.",
      author: "Jane Doe",
      role: "Sales Director, TechCorp",
      initials: "JD",
      rating: 5
    },
    {
      text: "The email campaign tools have increased our response rates by 45%. We're now connecting with prospects we couldn't reach before.",
      author: "Mark Smith",
      role: "Marketing Manager, GrowthBiz", 
      initials: "MS",
      rating: 5
    },
    {
      text: "Customer insights generated by the AI have helped us tailor our offerings and improve client satisfaction across the board.",
      author: "Alex Johnson",
      role: "Customer Success, InnovateCo",
      initials: "AJ",
      rating: 5
    }
  ];

  return (
    <div className="py-20 px-4 bg-background">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
            Trusted by <span className="text-yellow-400">industry leaders</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            See what our customers say about their experience with atWork.ai
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="flex h-full flex-col bg-card border border-border rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300">
              <div className="flex-auto p-8">
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <p className="text-foreground leading-relaxed text-lg">
                  "{testimonial.text}"
                </p>
              </div>
              <div className="p-8 pt-0">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div className="h-12 w-12 rounded-full bg-gradient-to-br from-yellow-400 to-yellow-600 flex items-center justify-center text-neutral-900 font-bold text-lg">
                      {testimonial.initials}
                    </div>
                  </div>
                  <div className="grow ml-4">
                    <h3 className="font-semibold text-foreground text-lg">
                      {testimonial.author}
                    </h3>
                    <p className="text-muted-foreground">
                      {testimonial.role}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
